import { Row } from '@tanstack/react-table';
import { CirclePlusIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import i18n from '@/core/i18n';

import { GenerateBillAddOverheadButtonRow, GenerateBillListItem } from '../../../types';
import { AddedProjectActions, OverheadActions } from '../generate-bills-table.types';

/** Button row that lets the user append an ad-hoc overhead or project line to a member. */
export const AddCustomLineButton = ({
  row,
  overheadActions,
  addedProjectActions,
}: {
  row: Row<GenerateBillListItem>;
  overheadActions: OverheadActions;
  addedProjectActions: AddedProjectActions;
}) => {
  const { memberId, currencyCode } = row.original as unknown as GenerateBillAddOverheadButtonRow;

  return (
    <div className="flex items-center py-3 pl-10">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="h-9 select-none gap-2 px-3 py-2 text-sm font-medium"
            onClick={event => event.stopPropagation()}
          >
            <CirclePlusIcon size={16} />
            {i18n.t('authenticated.bills:new.overhead.addCustomLine')}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <DropdownMenuItem onClick={() => overheadActions.addOverhead(memberId, currencyCode)}>
            {i18n.t('authenticated.bills:lineItemActions.addOverhead')}
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => addedProjectActions.addProject(memberId, currencyCode)}>
            {i18n.t('authenticated.bills:lineItemActions.addProject')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
